<script lang="ts">
  import { recommendation } from "../../stores/recommendation"

  import ProductListItem from "./ProductListItem.svelte"

  // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
  $: details = $recommendation.details
</script>

{#if details}
  <ul class={"product-list " + (details.products.length === 1 ? "single-product" : "multiple-products")}>
    {#each details.products as product}
      <li class="product-list-item-container">
        <ProductListItem product={product} />
      </li>
    {/each}
  </ul>
{/if}
